import { PeopleTeam24Filled, PeopleTeam24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const R9App = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "R9App" */ "./R9App");
    return { default: namedExport.R9App };
});

export const R9: TeamAppConfig = {
    title: "R9",
    regularIcon: PeopleTeam24Regular,
    filledIcon: PeopleTeam24Filled,
    path: "/R9",
    description: "R9 app provides service, monitoring account and metrics information.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["R9", "metrics", "mdm"],
    app: R9App
};
